import { call, takeLatest } from 'redux-saga/effects'
import { saveCateringData, clearCateringData, getCateringData } from 'utils/cateringStorage'
import {
    SAVE_CATERING_ADDRESS,
    UPDATE_CATERING_ADDRESS,
    SET_CATERING_SCHEDULE,
    CLEAR_CATERING_SCHEDULE
} from './actions'

// Saga workers
export function* saveCateringAddressSaga(action) {
    try {
        const { address, store } = action.payload
        yield call(saveCateringData, address, null, store)
    } catch (error) {
        console.error('Error saving catering address:', error)
    }
}

export function* updateCateringAddressSaga(action) {
    try {
        const { address, schedule, store } = action.payload
        const currentData = yield call(getCateringData)
        const updatedAddress = currentData.address ? { ...currentData.address, ...address } : address
        yield call(saveCateringData, updatedAddress, schedule || currentData.schedule, store || currentData.store)
    } catch (error) {
        console.error('Error updating catering address:', error)
    }
}

export function* setCateringScheduleSaga(action) {
    try {
        const { schedule, address, store } = action.payload
        const currentData = yield call(getCateringData)
        yield call(saveCateringData, address || currentData.address, schedule, store || currentData.store)
    } catch (error) {
        console.error('Error setting catering schedule:', error)
    }
}

export function* clearCateringScheduleSaga() {
    try {
        const currentData = yield call(getCateringData)
        yield call(saveCateringData, currentData.address, null, currentData.store)
    } catch (error) {
        console.error('Error clearing catering schedule:', error)
    }
}


// Saga watcher
export default function* cateringSaga() {
    yield takeLatest(SAVE_CATERING_ADDRESS, saveCateringAddressSaga)
    yield takeLatest(UPDATE_CATERING_ADDRESS, updateCateringAddressSaga)
    yield takeLatest(SET_CATERING_SCHEDULE, setCateringScheduleSaga)
    yield takeLatest(CLEAR_CATERING_SCHEDULE, clearCateringScheduleSaga)
}
